import { Button } from "@biteship/atom";
import { ReactComponent as WhatsAppLogo } from "../../tickets/images/WhatsApp.svg";

export default function IntegrationHeader() {
  return (
    <div className="flex items-center justify-between mb-12">
      <h1 className="text-lg md:text-xl font-bold mb-0">Integrasi</h1>
      <Button
        onClick={() => {
          window.open(
            "https://api.whatsapp.com/send?phone=6281399045077&text=Hai%20Biteship,%20saya%20ingin%20menanyakan%20perihal%20"
          );
          // trackEvent("Ticket ContactCS");
        }}
        title={
          <div className="font-bold text-gray-900 flex items-center text-xs md:text-sm">
            <WhatsAppLogo
              className="w-4 h-4 md:w-5 md:h-5 text-gray-900 flex-shrink-0 mr-1.5 md:mr-2"
              aria-hidden
            />
            Hubungi CS
          </div>
        }
        secondary
        className="justify-center border-neutral-40"
      />
    </div>
  )
}